module.exports = __webpack_public_path__ + "static/media/icn_crousal_card_1.2bc3af0f.svg";